import extendNode from '../extendNode.mjs'
import useArCatNode from '../_AR_CAT/useArCatNode.jsx'
import meta from './metaBdlogicUi.mjs'

export default () => {
    const ArCatNode = useArCatNode()

    return extendNode(ArCatNode, {
        ...meta,

        isHidden(map, node) {
            if ('SA_MAP' === map.data.mapTypeCode) {
                return true
            }

            if (! node.parent) {
                return false
            }

            const {ruleType} = node.parent.data

            if ('BT' !== ruleType) {
                return true
            }

            for (const n of node.parent.trueChain) {
                const {bizNodeType} = n.data

                if ('UE' === bizNodeType) {
                    return true
                }
            }
        },
    })
}
